import { apiClient } from './api';
import {
  SummaryStatistics,
  TimelineDataPoint,
  CountryStatistic,
  AsnStatistic,
  GeoJsonResponse,
  RecentActivity,
  EventRateResponse,
  ApiKeyEventRateResponse,
  BlacklistHourlyStatisticsResponse,
} from '../types/api';

export const statisticsService = {
  getSummary: async (): Promise<SummaryStatistics> => {
    const { data } = await apiClient.get('/statistics/summary');
    return data;
  },

  getTimeline: async (from?: string, to?: string, interval: string = 'hour'): Promise<TimelineDataPoint[]> => {
    const { data } = await apiClient.get('/statistics/timeline', {
      params: { from, to, interval },
    });
    return data;
  },

  getTopCountries: async (limit: number = 10, since?: string): Promise<CountryStatistic[]> => {
    const { data } = await apiClient.get('/statistics/countries', {
      params: { limit, since },
    });
    return data;
  },

  getTopAsns: async (limit: number = 10, since?: string): Promise<AsnStatistic[]> => {
    const { data } = await apiClient.get('/statistics/asns', {
      params: { limit, since },
    });
    return data;
  },

  getGeoJson: async (limit: number = 1000, since?: string): Promise<GeoJsonResponse> => {
    const { data } = await apiClient.get('/statistics/geojson', {
      params: { limit, since },
    });
    return data;
  },

  getRecentActivity: async (): Promise<RecentActivity> => {
    const { data } = await apiClient.get('/statistics/recent-activity');
    return data;
  },

  getEventRates: async (hours: number = 24): Promise<EventRateResponse> => {
    const { data } = await apiClient.get('/statistics/event-rates', {
      params: { hours },
    });
    return data;
  },

  getApiKeyEventRates: async (hours: number = 24, apiKeyId?: number): Promise<ApiKeyEventRateResponse> => {
    const { data } = await apiClient.get('/statistics/api-key-rates', {
      params: { hours, apiKeyId },
    });
    return data;
  },

  getBlacklistHourlyStatistics: async (hours: number = 24): Promise<BlacklistHourlyStatisticsResponse> => {
    const { data } = await apiClient.get('/statistics/blacklist-hourly', {
      params: { hours },
    });
    return data;
  },
};
